import { render, staticRenderFns } from "./CustomerPrintInvoices.vue?vue&type=template&id=4e815a60"
import script from "./CustomerPrintInvoices.vue?vue&type=script&lang=js"
export * from "./CustomerPrintInvoices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports